import Auth from './Auth';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const loginListeners = [];
const guestUpdateListeners = [];

class Api {

  static addLoginListener(listener) {
    loginListeners.push(listener);
  }

  static addGuestUpdateListener(listener) {
    guestUpdateListeners.push(listener);
  }

  static fetch(url, params) {
    var token = Auth.getAuthToken();
    if (token) {
      params = Object.assign({}, params);
      params.headers = Object.assign({}, params.headers);
      params.headers.Authorization = 'Bearer ' + token;
    }
    return fetch(BASE_URL+url, params)
      .then(response => response.json());
  }

  static fetchJson(method, url, data) {
    return Api.fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
  }

  static sendEmailConfirmation(emailAddress) {
    const formData = new FormData();
    formData.append('email', emailAddress);

    Api.fetch('/verify/email', {
      method: 'POST',
      body: formData,
    });
  }

  static sendSmsConfirmation(phoneNumber) {
    const formData = new FormData();
    formData.append('phone_number', phoneNumber);

    return Api.fetch('/verify/phone', {
      method: 'POST',
      body: formData,
    });
  }

  static confirmSms(phoneNumber, verifyCode) {
    const formData = new FormData();
    formData.append('phone_number', phoneNumber);
    formData.append('verify_code', verifyCode);

    return Api.fetch('/confirm/phone', {
      method: 'POST',
      body: formData,
    });
  }

  static getFacebookLoginUrl() {
    return BASE_URL + '/verify/facebook';
  }

  static goToFacebookLogin() {
    location.href = Api.goToFacebookLogin();
  }

  static fetchEventInfo() {
    return Api.fetch('/event/info')
      .then(result => {
        if (result.code) {
          Auth.logout();
        }
        for (let i = 0; i < loginListeners.length; i++) {
          loginListeners[i](result);
        }
        return result;
      });
  }

  static setGuestRsvp(guestId, rsvp) {
    return Api.fetchJson('PUT', '/guests/'+guestId, { rsvp })
      .then(result => {
        if (result.code) {
          return;
        }
        for (let i = 0; i < guestUpdateListeners.length; i++) {
          guestUpdateListeners[i](guestId, { rsvp });
        }
        return result;
      });
  }

  static putGuestInfo(guestId, data) {
    return Api.fetchJson('PUT', '/guests/'+guestId, data);
  }

  static teamGetInvitations() {
    return Api.fetch('/team/invitations');
  }

  static teamUpdateInvitationsOrder(orderedIds) {
    return Api.fetchJson('PUT', '/team/invitations/order', {
      ids: orderedIds,
    });
  }

  static teamUpdateInvitationGuestsOrder(invitationId, orderedGuestIds) {
    return Api.fetchJson('PUT', '/team/invitations/'+invitationId+'/guests/order', {
      guest_ids: orderedGuestIds,
    });
  }

  static teamSetInvitationName(invitationId, name) {
    return Api.fetchJson('PUT', '/team/invitations/'+invitationId, { name });
  }

  static teamLoginAsGuest(guestId) {
    return Api.fetchJson('GET', '/team/guests/'+guestId+'/login')
      .then(result => {
        if (result.token) {
          Auth.setAuthToken(result.token);
          location.reload();
        }
      });
  }
}

export default Api;



// WEBPACK FOOTER //
// ./src/Api.js